import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import {
  addressObject,
  lang,
  permissions,
  scssVariables as variables,
  scssVariables,
  upperFirstChar,
  withRouter
} from 'src/helpers';
import {
  SelectField,
  SearchTextField,
  MCButton,
  TextField,
  ToggleSwitch,
  PopoverMenu,
  View,
  TabMenu,
  MCText
} from 'src/components/basic';
import { TableLibrary } from 'src/components/complex';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { remCss } from 'src/helpers';
import model from './model';
import constants from 'src/constants';
import moment from 'moment/moment';
import AlertManager from 'src/components/alert/AlertManager';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';
import invitationsModel from './invitationsModel';
import HospitalSelect from 'src/components/complex/HospitalSelect';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

class Doctors extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    invitationsModel.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    invitationsModel.unsubscribe(this.subscription);
  }
  onSearchTextChange = (text, model) => {
    model.setStateSilent({ search: text, pageIndex: 0 });
    model.handleChangeSearch(text);
    if (!text) {
      model.setListStateSilent({ items: [], total: 0 }, 'search');
      model.refresh();
    }
  };
  onSearchChange = (n, v, model) => {
    if (v?.toString() === model.input(n)?.toString()) return;
    model.setStateSilent({ [n]: v, pageIndex: 0 });
    model.setListStateSilent({ items: [], total: 0 }, model.getCurrentId());
    model.refresh();
  };

  renderSearchHeader = (model) => {
    const { PAGES } = permissions;
    const auth = model.state.user || {};
    return (
      <View
        style={{
          flexDirection: 'row',
          marginBottom: remCss(15),
          gap: remCss(15),
          flexWrap: 'wrap'
        }}
      >
        <SearchTextField
          template={'2'}
          width={300}
          placeholder={LANG_CONST.search}
          onChange={(text) => {
            this.onSearchTextChange(text, model);
          }}
          value={model.input('search')}
        />
        {model.id === 'ClinicDoctorsModel' && (
          <SelectField
            style={{ zIndex: 2, minWidth: remCss(300) }}
            template={'6'}
            options={constants.general.specialist}
            name={'specialist'}
            placeholder={LANG_CONST.speciality}
            value={model.input('specialist')}
            onChange={(n, v) => {
              this.onSearchChange(n, v, model);
            }}
          />
        )}
        <HospitalSelect
          template={6}
          styles={{ maxWidth: remCss(300), minWidth: remCss(300) }}
          placeholder={LANG_CONST.location}
          name={'hospitalId'}
          value={model.input('hospitalId')}
          onChange={(n, v) => {
            this.onSearchChange(n, v, model);
          }}
        />
        <View style={{ flex: 1 }} />
        <MCButton
          primary
          medium
          dark
          radius
          style={{ height: remCss(50) }}
          onClick={() => {
            if (auth?.status === constants.general.userStatus.disabled) {
              return model.emit('checkDisabledAccount', auth);
            }
            if (!permissions.PAGES.DOCTORS_ADD_PAGE.isActive) {
              return AlertManager.popup(AlertManager.TYPES.INFO, {
                width: remCss(650),
                title: LANG_CONST.manager_no_permissions.doctors,
                actionButton: {
                  label: LANG_CONST.buttons.ok,
                  action: ({ hide }) => hide()
                }
              });
            }
            this.navigate(PAGES.DOCTORS_ADD_PAGE.match());
          }}
          label={LANG_CONST.buttons.add_new}
        />
      </View>
    );
  };

  renderDoctors() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();
    let clinicId = model.userId || 0;
    const auth = model.state.user || {};
    const medium = !this.props.screenDetail?.isLargeScreen;

    const columns = [
      {
        label: LANG_CONST.doctors,
        sort: { sortKey: 'name' },
        resize: true,
        renderCell: (item) => {
          return <ShortInfo user={item} to={permissions.profilePath(item)} vertical={medium} />;
        }
      },
      {
        label: LANG_CONST.location,
        resize: true,
        renderCell: (item) => (
          <MCText
            label={item.hospitals
              ?.map(
                (h) =>
                  addressObject({ cityAddress: h.city, stateAddress: h.state })
                    .fullAddressNameReverse
              )
              .join('\n')}
          />
        )
      },
      {
        label: LANG_CONST.commission,
        resize: true,
        sort: { sortKey: 'comission' },
        minWidth: '130',
        width: '15%',
        renderCell: (item) => {
          const canEdit = permissions.PAGES.DOCTORS_EDIT_PAGE.checkActive({
            auth,
            doctor: item
          });
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: remCss(10) }}>
              <TextField
                style={{ width: remCss(65) }}
                inputProps={{ style: { textAlign: 'center' }, min: 0, max: 100 }}
                type='number'
                name='comission'
                template={5}
                disabled={!canEdit}
                value={((item.clinics || {})[clinicId] || {}).comission || 0}
                onChange={(n, v) => model.onChangeComission(item, v)}
                onBlur={(n, v) => model.saveComission(item, v)}
              />
              <span>%</span>
            </div>
          );
        }
      },
      !medium && {
        label: LANG_CONST.joining_date,
        resize: true,
        sort: { sortKey: 'created' },
        minWidth: '150',
        width: '15%',
        renderCell: (item) => (item.created ? moment(item.created).format('DD.MM.YYYY') : null)
      },
      {
        label: (
          <div style={{ width: remCss(92), textAlign: 'center' }}>{lang.t(LANG_CONST.active)}</div>
        ),
        resize: true,
        width: `${remCss(112)}px`,
        renderCell: (item) => {
          const canEdit = permissions.PAGES.DOCTORS_EDIT_PAGE.checkActive({
            auth: model.getUser(),
            doctor: item
          });
          return (
            <View style={{ gap: remCss(10), alignItems: 'center', width: remCss(92) }}>
              <ToggleSwitch
                className={!canEdit ? 'disabled' : ''}
                disabled={model.getApiState('active').loading || !canEdit}
                checked={model.checkWithUpdating(
                  item,
                  'active',
                  item.status !== constants.general.userStatus.disabled
                )}
                onChange={() => model.updateActive(item)}
              />
            </View>
          );
        }
      },
      !medium && {
        label: LANG_CONST.actions,
        cellStyles: { textAlign: 'end' },
        minWidth: '150',
        width: '15%',
        renderCell: this.renderDoctorActions
      }
    ].filter((i) => !!i);

    return (
      <>
        {this.renderSearchHeader(model)}
        <TableLibrary
          loading={loading}
          className={medium && 'mc-row2'}
          renderExtend={
            medium
              ? (item) => {
                  return (
                    <div className={'mc-flex-20'}>
                      <MCText
                        flex
                        label={
                          lang.t(LANG_CONST.joining_date) +
                          ': ' +
                          (item.created ? moment(item.created).format('MM.DD.YYYY') : '')
                        }
                      />
                      {this.renderDoctorActions(item)}
                    </div>
                  );
                }
              : null
          }
          noResults={noResults}
          searchQuery={searchQuery}
          sortBy={model.state.sortBy}
          selectedPage={model.state.pageIndex}
          total={total}
          limit={model.listLimit}
          onSortChange={(sortBy) => {
            model.handleChange('sortBy', sortBy);
            model.setListState({ items: [] }, model.getCurrentId(), null, true);
            model.loadMore();
          }}
          onSetPage={(v) => {
            model.handleChange('pageIndex', v);
            model.setListState({ items: [] }, model.getCurrentId(), null, true);
            model.loadMore();
          }}
          key={medium ? 1 : 0}
          columns={columns}
          data={items}
          otherProps={{
            cell: () => ({
              style: {
                alignItems: 'flex-start'
              }
            })
          }}
        />
      </>
    );
  }

  renderDoctorActions = (item) => {
    const { PAGES } = permissions;
    const canEdit = permissions.PAGES.DOCTORS_EDIT_PAGE.checkActive({
      auth: model.state?.user,
      doctor: item
    });
    return (
      <div
        className={'mc-flex'}
        style={{
          justifyContent: 'flex-end'
        }}
      >
        {canEdit && (
          <MCButton
            type={'link'}
            iconname={BASE_ICONS.EDIT}
            to={PAGES.DOCTORS_EDIT_PAGE.match(item.id)}
            primary
            style={{ minWidth: remCss(42) }}
            light
            radius
            padding={5}
            width={42}
          />
        )}
        <MCButton
          to={PAGES.DOCTORS_DETAIL_PAGE.match(item?.username)}
          type={'link'}
          style={{ minWidth: remCss(42) }}
          iconname={BASE_ICONS.EYE_FILL}
          fill={scssVariables['colors-mc-primary']}
          fillOpacity={'0.5'}
          width={42}
          dark
          padding={5}
          radius
        />
        {canEdit && (
          <View style={{ minWidth: remCss(24) }}>
            <PopoverMenu
              arrowOffset={30}
              placement={'bottom-end'}
              popupMenuStyle={{
                backgroundColor: 'white',
                padding: remCss(10),
                overflow: 'none'
              }}
              menu={() => (
                <>
                  <MCButton
                    iconname={BASE_ICONS.DELETE}
                    width={42}
                    light
                    radius
                    secondary
                    padding={5}
                    onClick={(e) => {
                      e.preventDefault();
                      AlertManager.popup(AlertManager.TYPES.WARN, {
                        close: false,
                        title: LANG_CONST.notice.delete,
                        cancelButton: {
                          label: LANG_CONST.buttons.no,
                          action: (actions) => actions.hide()
                        },
                        actionButton: {
                          label: LANG_CONST.buttons.yes,
                          action: (actions) => {
                            actions.setLoading(true);
                            model.remove(item, () => {
                              actions.setLoading(false);
                              actions.hide();
                            });
                          }
                        }
                      });
                    }}
                  />
                </>
              )}
              className={'mc-pointer mc-flex mc-flex-center'}
            >
              {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={24} />}
            </PopoverMenu>
          </View>
        )}
      </div>
    );
  };

  renderInvitationActions = (item) => {
    const { PAGES } = permissions;
    const auth = invitationsModel.state.user || {};
    const canEdit = permissions.PAGES.DOCTORS_EDIT_PAGE.checkActive({
      auth,
      doctor: item
    });
    return (
      <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
        {canEdit && item.status === 'pending' && (
          <MCButton
            type={'link'}
            iconname={BASE_ICONS.EDIT}
            to={PAGES.DOCTORS_ADD_PAGE.match(item.id)}
            primary
            style={{ minWidth: remCss(42) }}
            light
            radius
            padding={5}
            width={42}
          />
        )}
        {item.status !== 'accepted' && (
          <MCButton
            primary
            light
            radius
            medium
            padding={1}
            style={{
              paddingHorizontal: remCss(9),
              paddingVertical: remCss(5.5),
              fontWeight: 400
            }}
            onClick={(e) => {
              e.preventDefault();
              AlertManager.popup(AlertManager.TYPES.INFO, {
                close: false,
                title: LANG_CONST.notice.resend,
                cancelButton: {
                  label: LANG_CONST.buttons.no,
                  action: (actions) => actions.hide()
                },
                actionButton: {
                  label: LANG_CONST.buttons.yes,
                  action: (p) => {
                    p.setLoading(true);
                    invitationsModel.resend(item.id, (err) => {
                      p.setLoading(false);
                      if (!err)
                        AlertManager.popup(AlertManager.TYPES.INFO, {
                          close: false,
                          width: 450,
                          title: lang.t(LANG_CONST.notice.sent_invitation, {
                            type: lang.t(LANG_CONST.patient).toLowerCase()
                          }),
                          actionButton: {
                            label: LANG_CONST.buttons.ok,
                            action: (actions) => {
                              actions.hide();
                            }
                          }
                        });
                    });
                  }
                }
              });
            }}
          >
            <span
              style={{ fontWeight: 400, fontFamily: variables['fonts-mc-regular'] }}
              className={'mc-text-truncate'}
            >
              {lang.t(LANG_CONST.buttons.resend)}
            </span>
          </MCButton>
        )}
        {canEdit && (
          <View style={{ minWidth: remCss(24) }}>
            <PopoverMenu
              arrowOffset={30}
              placement={'bottom-end'}
              popupMenuStyle={{
                backgroundColor: 'white',
                padding: remCss(10),
                overflow: 'none'
              }}
              menu={() => (
                <>
                  <MCButton
                    iconname={BASE_ICONS.DELETE}
                    width={42}
                    light
                    radius
                    secondary
                    padding={5}
                    onClick={(e) => {
                      e.preventDefault();
                      AlertManager.popup(AlertManager.TYPES.WARN, {
                        close: false,
                        title: LANG_CONST.notice.delete,
                        cancelButton: {
                          label: LANG_CONST.buttons.no,
                          action: (actions) => actions.hide()
                        },
                        actionButton: {
                          label: LANG_CONST.buttons.yes,
                          action: (actions) => {
                            actions.setLoading(true);
                            invitationsModel.remove(item, () => {
                              actions.setLoading(false);
                              actions.hide();
                            });
                          }
                        }
                      });
                    }}
                  />
                </>
              )}
              className={'mc-pointer mc-flex mc-flex-center'}
            >
              {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={24} />}
            </PopoverMenu>
          </View>
        )}
      </div>
    );
  };

  renderInvitations = () => {
    let loading = invitationsModel.refreshing();
    let noResults = invitationsModel.noResults();
    let searchQuery = invitationsModel.listInput('search');
    let items = invitationsModel.items();
    let { total = 0 } = invitationsModel.getCurrent();
    const medium = !this.props.screenDetail?.isLargeScreen;

    const columns = [
      {
        label: LANG_CONST.doctors,
        resize: true,
        renderCell: (item) => (
          <div className={'mc-flex-5-col'}>
            <ShortInfo user={item} fullname={item.fullname} vertical={medium} />
            {medium && <MCText label={item.email} numberOfLines={1} heading size={18} />}
            {medium && (
              <MCText
                label={formatPhoneNumberIntl((item.phoneNumber || '').toString())}
                numberOfLines={1}
                heading
                size={18}
                weight={400}
              />
            )}
          </div>
        )
      },
      !medium && {
        label: LANG_CONST.email_phone,
        resize: true,
        minWidth: '250',
        width: '20%',
        renderCell: (item) => (
          <div className={'mc-flex-5-col'}>
            <MCText label={item.email} numberOfLines={1} heading size={18} weight={500} />
            <MCText
              label={formatPhoneNumberIntl((item.phoneNumber || '').toString())}
              numberOfLines={1}
              heading
              size={18}
              weight={400}
            />
          </div>
        )
      },
      {
        label: LANG_CONST.location,
        resize: true,
        renderCell: (item) => (
          <MCText
            label={item.hospitals
              ?.map(
                (h) =>
                  addressObject({ cityAddress: h.city, stateAddress: h.state })
                    .fullAddressNameReverse
              )
              .join('\n')}
          />
        )
      },
      {
        label: LANG_CONST.joining_date,
        resize: true,
        minWidth: '150',
        width: '15%',
        renderCell: (item) => (item.date ? moment(item.date).format('DD.MM.YYYY') : null)
      },
      {
        label: LANG_CONST.status,
        resize: true,
        minWidth: '120',
        width: '15%',
        renderCell: (item) => (
          <button className={'mc-status-' + item.status}>
            {lang.t(upperFirstChar(item.status))}
          </button>
        )
      },
      !medium && {
        label: LANG_CONST.actions,
        cellStyles: { textAlign: 'end' },
        minWidth: '150',
        width: '15%',
        renderCell: this.renderInvitationActions
      }
    ].filter((c) => !!c);

    return (
      <>
        {this.renderSearchHeader(invitationsModel)}
        <TableLibrary
          otherProps={{
            cell: () => ({
              style: {
                alignItems: 'flex-start'
              }
            })
          }}
          className={medium ? 'mc-row2' : ''}
          renderExtend={medium && this.renderInvitationActions}
          loading={loading}
          noResults={noResults}
          searchQuery={searchQuery}
          sortBy={invitationsModel.state.sortBy}
          selectedPage={invitationsModel.state.pageIndex}
          total={total}
          limit={invitationsModel.listLimit}
          onSortChange={(sortBy) => {
            invitationsModel.handleChange('sortBy', sortBy);
            invitationsModel.setListState(
              { items: [] },
              invitationsModel.getCurrentId(),
              null,
              true
            );
            invitationsModel.loadMore();
          }}
          onSetPage={(v) => {
            invitationsModel.handleChange('pageIndex', v);
            invitationsModel.setListState(
              { items: [] },
              invitationsModel.getCurrentId(),
              null,
              true
            );
            invitationsModel.loadMore();
          }}
          key={medium ? 1 : 0}
          columns={columns}
          data={items}
        />
      </>
    );
  };

  render() {
    return (
      <div className={'mc-container-content mc-all-doctors'}>
        <div className={'mc-container-content__header'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.doctors)}</span>
        </div>
        <div className={'mc-container-content__body'} style={{ zIndex: 0 }}>
          <div className={'mc-container-content__body-header'}>
            <div className={'mc-grow'}>
              <TabMenu
                tabs={[
                  { id: 'doctors', name: LANG_CONST.doctors },
                  {
                    id: 'invitations',
                    name: LANG_CONST.invitations
                  }
                ]}
                tab={{ id: model.input('tab') }}
                setTab={(tab) => {
                  if (tab.id === model.input('tab')) {
                    model.setListStateSilent({ items: [] });
                    model.loadMore();
                  }
                  model.setState({ tab: tab.id });
                }}
                type={'panner'}
              />
            </div>
          </div>

          <div className={'mc-tab-box-opacity mc-grow'}>
            <div
              className={
                'mc-tab-content mc-flex-col ' +
                (model.input('tab') === 'doctors' ? '' : 'mc-inactive')
              }
            >
              <div className={'mc-container-content__body-content'}>{this.renderDoctors()}</div>
            </div>
            <div
              className={
                'mc-tab-content mc-flex-col ' +
                (model.input('tab') !== 'doctors' ? '' : 'mc-inactive')
              }
            >
              <div className={'mc-container-content__body-content'}>{this.renderInvitations()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Doctors);
